module.exports = __webpack_public_path__ + "static/Vazir-Medium-1d5e0c515fc1f542653a0f2b1ccf3cce.woff";